(function () {
  'use strict';
  if (!previewMode && $('#vsl-video').length > 0) {
    // Variáveis
    const $videoEl = $('#vsl-video');
    const plataform = $videoEl.data('v-plataform');
    const delayEnable = $videoEl.data('v-delay-enable');
    const syncDelayVideo = $videoEl.data('v-delay-sync');
    const delayStore = $videoEl.data('v-delay-store');
    const delayTime = $videoEl.data('v-delay-time') || '00:00';
    const delayArr = delayTime.split(':');
    const delayMin = Number(delayArr[0]);
    const delaySec = Number(delayArr[1]);
    const SECONDS_TO_DISPLAY = delayMin * 60 + delaySec;
    console.log(SECONDS_TO_DISPLAY + ' SEGUNDOS DE DELAY...');
    const delayElements = $videoEl.data('v-delay-elements') || '';
    const $delayElements = $(delayElements);
    let delayElCurStatus = 'hide';

    // Exibe/Oculta os elementos com delay
    function toggleDelayEl(ac = 'show') {
      if (ac === delayElCurStatus) {
        return false;
      }
      if (ac === 'show') {
        console.log('SHOW ELEMENTS!');
        localStorage.setItem('vsl_view' + baseLanding, 1);
        delayElCurStatus = 'show';
      } else if (ac === 'hide') {
        console.log('HIDE ELEMENTS!');
        delayElCurStatus = 'hide';
      }
      if (delayEnable == 1 && SECONDS_TO_DISPLAY > 0 && $delayElements.length > 0) {
        $delayElements.each(function () {
          const $el = $(this);
          if (ac === 'show') {
            $el.show();
          } else if (ac === 'hide') {
            $el.hide();
          }
        });
      }
    }

    if (delayStore == 1) {
      if (localStorage.getItem('vsl_view' + baseLanding) == 1) {
        toggleDelayEl('show');
      }
    }

    // Delay sem sincronia de vídeo
    if (delayEnable == 1 && syncDelayVideo != 1) {
      setTimeout(() => {
        toggleDelayEl('show');
      }, 1000 * SECONDS_TO_DISPLAY);
    }

    // Delay com sincronia de vídeo
    if (delayEnable == 1 && syncDelayVideo == 1) {
      // YOUTUBE
      if (plataform === 'youtube') {
        const $videoPlayer = $('#v-player');
        const videoId = YouTubeGetID($videoPlayer.data('video-url'));
        let videoTimer;
        if (videoId) {
          // Variáveis
          const tag = document.createElement('script');
          tag.src = 'https://www.youtube.com/iframe_api';
          const firstScriptTag = document.getElementsByTagName('script')[0];
          firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
          // Inicia o player
          window.ytVideoID = videoId;
          window.onYouTubeIframeAPIReady = function () {
            window.ytPlayer = new YT.Player('v-player', {
              videoId: window.ytVideoID,
              playerVars: {
                controls: 0,
                disablekb: 1,
                modestbranding: 1,
                color: 'white',
                playsinline: 1,
                rel: 0,
                playlist: window.ytVideoID,
                loop: 1,
              },
              events: {
                onReady: onYtPlayerReady,
              },
            });
          };
          function onYtPlayerReady(event) {
            event.target.playVideo();
            checkYtPlayerTime();
          }
          function checkYtPlayerTime() {
            videoTimer = setInterval(function () {
              if (window.ytPlayer.getCurrentTime() >= SECONDS_TO_DISPLAY) {
                toggleDelayEl('show');
                clearInterval(videoTimer);
              }
            }, 500);
          }
        }
      }

      // VIMEO
      if (plataform === 'vimeo') {
        const $vimeoIframe = $videoEl.find('iframe')[0];
        const vimeoPlayer = new Vimeo.Player($vimeoIframe);
        let videoTimer;
        vimeoPlayer.on('play', function () {
          if (videoTimer === undefined) {
            videoTimer = setInterval(() => {
              vimeoPlayer.getCurrentTime().then(function (currentTime) {
                if (currentTime >= SECONDS_TO_DISPLAY) {
                  toggleDelayEl('show');
                  clearInterval(videoTimer);
                }
              });
            }, 500);
          }
        });
      }

      // PANDA
      if (plataform === 'panda') {
        const pandaApi = 'https://player.pandavideo.com.br/api.v2.js';
        const pandaIframeID = $videoEl.find('iframe').attr('id');
        if (!document.querySelector(`script[src='${pandaApi}']`)) {
          let s = document.createElement('script');
          s.src = pandaApi;
          s.async = true;
          document.head.appendChild(s);
        }
        window.pandascripttag = window.pandascripttag || [];
        window.pandascripttag.push(function () {
          const p = new PandaPlayer(pandaIframeID, {
            onReady() {
              p.onEvent((e) => {
                const type = e.message;
                if (type === 'panda_timeupdate') {
                  const { currentTime, isMutedIndicator } = e;
                  if (isMutedIndicator) return;
                  if (currentTime < SECONDS_TO_DISPLAY) {
                    toggleDelayEl('hide');
                  } else if (currentTime >= SECONDS_TO_DISPLAY) {
                    toggleDelayEl('show');
                  }
                }
              });
            },
          });
        });
      }

      // VTURB
      if (plataform === 'vturb') {
        let attempts = 0;
        function startWatchVideoProgress() {
          if (typeof smartplayer === 'undefined' || !(smartplayer.instances && smartplayer.instances.length)) {
            if (attempts >= 10) return;
            attempts += 1;
            return setTimeout(function () {
              startWatchVideoProgress();
            }, 1000);
          }
          smartplayer.instances[0].on('timeupdate', () => {
            if (delayElCurStatus === 'show' || smartplayer.instances[0].smartAutoPlay) return;
            if (smartplayer.instances[0].video.currentTime >= SECONDS_TO_DISPLAY) {
              toggleDelayEl('show');
            }
          });
        }
        startWatchVideoProgress();
      }

      // WISTIA
      if (plataform === 'wistia') {
        const wqVideoID = getWistiaVideoID();
        let videoTrigger = false;
        window._wq = window._wq || [];
        _wq.push({
          id: wqVideoID,
          onReady: function (video) {
            video.bind('secondchange', function () {
              if (video.time() >= SECONDS_TO_DISPLAY && videoTrigger !== true) {
                videoTrigger = true;
                toggleDelayEl('show');
              }
            });
          },
        });
        function getWistiaVideoID() {
          if (typeof wistiaEmbeds === 'object' && wistiaEmbeds[0]) {
            return wistiaEmbeds[0].data.media.hashedId;
          } else {
            const wistiaScriptSrcArr = $videoEl.find('script').first().attr('src').split('/');
            return wistiaScriptSrcArr[wistiaScriptSrcArr.length - 1].split('.')[0];
          }
        }
      }
    }
  }
})();
